import { useContent } from "@/context/ContentContext";
import useMeta from "@/hooks/useMeta";
import { PageHero } from "@/components/site/PageHero";
import { CtaBand } from "@/components/site/CtaBand";
import { SessionFormat } from "@/components/site/SessionFormat";
import { ServiceCards } from "@/components/site/ServiceCards";

export default function Services() {
  const { content } = useContent();
  const s = content.services;
  useMeta(
    "Services · Online psychotherapy Ontario",
    "Virtual individual psychotherapy and couples/parenting support across Ontario with Violeta Dubov, Registered Social Worker in Toronto, for adults (aged 18+)."
  );
  return (
    <>
      <PageHero eyebrow="Services" title={s.headline} testId="services-headline">{s.intro}</PageHero>
      <section className="wrap pb-8">
        <ServiceCards services={s.offered} more={content.home.services_more} />
      </section>
      <section className="wrap py-12">
        <SessionFormat s={s} />
      </section>
      <CtaBand title={content.home.final_cta_title} button={content.home.final_cta_button} />
    </>
  );
}
